import { useThemeStore } from "@stores/theme.store";
import moment from "moment-timezone";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
moment.locale("id");
export const AbsenceDetailPage = () => {
  const { state } = useLocation();
  const { setHeader, setAppBar } = useThemeStore((state) => state);

  useEffect(() => {
    setAppBar({ title: "Detail Absensi", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Detail Absensi",
      image: false,
    });
  }, [setHeader, setAppBar]);

  return (
    <>
      <div className="tw-px-4 tw-pt-2 tw-pb-20">
        <div className=" tw-rounded-lg card-body">
          <div className="tw-text-accent-primary tw-text-xs">Tanggal Absen</div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {moment(state.tanggal ?? Date.now()).format("dddd, DD MMMM YYYY")}
          </div>

          <div className="tw-text-accent-primary tw-text-xs">Alpa</div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {state.alpa ?? "-"} jam pelajaran
          </div>

          <div className="tw-text-accent-primary tw-text-xs">Sakit</div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {state.sakit ?? "-"} jam pelajaran
          </div>

          <div className="tw-text-accent-primary tw-text-xs">Izin</div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {state.ijin ?? "-"} jam pelajaran
          </div>

          <div className="tw-text-accent-primary tw-text-xs">Catatan</div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {state.catatan ?? "-"}
          </div>
        </div>
      </div>
    </>
  );
};
